 async function getScript() {
   (function(w, d, s, l, i) {
     w[l] = w[l] || [];
     w[l].push({
     });
     var f = d.getElementsByTagName(s)[0],
       j = d.createElement(s),
       dl = l != 'dataLayer' ? '&l=' + l : '';
     j.async = true;
     j.src = 'https://app.clicklease.com/jsdk/getScript';
     f.parentNode.insertBefore(j, f);
   })(window, document, 'script', 'dataLayer');
 }
 getScript();
